import React, { useState } from "react";
import { Helmet } from "react-helmet";
import laserweldingmachine from "../img/about/laserweldingmachine.jpeg";
import hydraulicsurface from "../img/about/hydraulicsurface.jpeg";
import VMC from "../img/about/VMC.jpeg";
import manuallathemachine from "../img/about/manuallathemachine.jpeg";
import plasticinjectionmoldingmachine from "../img/about/plasticinjectionmoldingmachine.jpeg";
import wirecutdem from "../img/about/wirecutdem.jpeg";
import journey1 from "../img/journey/1.jpg";
import journey2 from "../img/journey/2.jpg";
import journey3 from "../img/journey/3.jpg";
import journey4 from "../img/journey/4.jpg";
import journey5 from "../img/journey/5.jpg";
import journey6 from "../img/journey/6.jpg";
import journey7 from "../img/journey/7.jpg";
import journey8 from "../img/journey/9.jpg";
import journey9 from "../img/journey/9.jpg";
import crossline2 from "../images/background/cross-line2.png";
import journey10 from "../img/journey/10.jpg";
import ourjourneybanner from "../img/journey/our-journey-banner.jpg";

const Ourjourney = () => {
  const [currentIndex, setCurrentIndex] = useState(0); // Track the current index of the carousel

  const data = [
    {
      image: laserweldingmachine,
      title: "Laser Welding Machine",
      link: "#",
      description: "#",
    },
    {
      image: hydraulicsurface,
      title: "Hydraulic Surface Grinding Machine",
      link: "#",
      description: "#",
    },
    { image: VMC, title: "VMC", link: "#", description: "#" },
    {
      image: manuallathemachine,
      title: "Manual Lathe Machine",
      link: "#",
      description: "#",
    },
    {
      image: plasticinjectionmoldingmachine,
      title: "Plastic Injection Molding Machine",
      link: "#",
      description: "#",
    },
    { image: wirecutdem, title: "Wire Cut EDM", link: "#", description: "#" },
  ];

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : data.length - 1
    ); // Move to the previous item (wraps around)
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < data.length - 1 ? prevIndex + 1 : 0
    ); // Move to the next item (wraps around)
  };

  const [openSection, setOpenSection] = useState(null); // Track which section is open

  // Function to handle the toggle
  const toggleSection = (index) => {
    if (openSection === index) {
      setOpenSection(null); // Close the section if it's already open
    } else {
      setOpenSection(index); // Open the clicked section
    }
  };

  const timelineData = [
    {
      year: "2013",
      title: "START UP as incubation for LED lights",
      description:
        "As Indian LED industry was just getting evolved from CFL to LED, and no major manufacturing was visible in India, Spinoff took an initiative to get in manufacturing by starting with R&amp;D driven approach for NPD in LED lights , by doing product development in LED bulb and LED tube lights with power electronic and thermal treatment of aluminum and plastic with start up space in less then 200 sq ft area for in Mohali near Chandigarh.",
    },
    {
      year: "2014/2015",
      title: "Production- Phase-1- 12 SKU",
      description:
        "After successful trial of NPD Spinoff started manufacturing LED bulb, Tube lights and few other SKU total about 12 SKU in LED lights in different Sizes and shapes with best of quality and production facility in 20000 sq ft space partially occupied reserve for future.",
    },
    {
      year: "2016/2017",
      title: "Production- Phase-2- 40 SKU",
      description:
        "After successful commissioning of Phase-1 Spinoff started manufacturing COB lights down lighter and took total SKU from 12-40 in Design/Style application/in Home segment of LED lights with in-house production supported by in-house R&amp;D- with best of quality and production facility",
    },
    {
      year: "2018/2019",
      title: "Production- Phase-3- 100 SKU",
      description:
        "After successful commissioning of Phase-1 and 2, the more and more people are aware and LED was every one choice now, and price also have corrected to make it affordable and industry opened very widely and huge product range started coming from china – which gave us more chance of new product variant and now we have scaled up to 80SKU from 40-100 in Design/Style application/in Home and commercial segment of LED lights with in-house production supported by in-house R&amp;D- with best of quality and production facility",
    },
    {
      year: "2020",
      title: "Production- Phase-4- 200 SKU",
      description:
        "After successful commissioning of Phase-1/2/3, the more and more reach of us in residential housing/commercial building/architects and this phase we started working on solar lights in street lights and also industrial lighting for PHARMACEUTICAL and also in INSTITUTIONAL LED - people are aware and LED was every one choice now, and price also have corrected to make it affordable and industry opened very widely and huge product range started coming from china – which gave us more chance of new product variant and now we have scaled up to 200SKU from 100-100 in Design/Style application/in Home/commercial/industrial/institutional/Hospitality segment of LED lights with in-house production supported by in-house R&amp;D- with best of quality and production facility",
    },
    {
      year: "2021",
      title:
        "Phase-5- 400 SKU Plus New Mega factory with 250000 sq feet plot area",
      description:
        "This year too in addition to increase in SKU to more then 400 decision to start a new factory in RAJPURA for CNC laser cut and CNC bending machines in sheet metal body making for lights and its drivers",
    },
  ];
  return (
    <div className="page-content">
      <Helmet>
        <link rel="preload" href={ourjourneybanner} as="image" />
      </Helmet>
      <div
        className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center"
        data-stellar-background-ratio="0.5"
        style={{ backgroundImage: `url(${ourjourneybanner})` }}
      >
        <div className="overlay-main bg-black opacity-07" />
        <div className="container">
          <div className="sx-bnr-inr-entry">
            <div className="banner-title-outer">
              <div className="banner-title-name">
                <h2 className="m-tb0">Our Journey</h2>
                {/* <p>The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.</p> */}
              </div>
            </div>
            {/* BREADCRUMB ROW */}
            <div></div>
            {/* BREADCRUMB ROW END */}
          </div>
        </div>
      </div>
      <div className="journycont">
        <p>
          In the early decade beginning 2010, when the CFL industry was fading
          away and the LED industry was getting evolved, no major manufacturing
          was visible in India , then Spinoff Technopark took the initiative to
          get in the manufacturing by starting  the R&D Driven approach for
          New Product Development in LED Lights & LED Tube Lights with power
          electronic & thermal treatment of aluminum and plastic.
        </p>
        <p>
          In 2013, after successful trials of New Product Development , we
          Started Manufacturing LED bulbs , Tube Lights, and few other SKUs in
          different shapes & sizes with best of Quality & production facility in
          Industrial Area, Mohali ( Punjab )
        </p>
      </div>
      {/* INNER PAGE BANNER END */}
      {/* ABOUT COMPANY SECTION START */}
      <div className="section-full1 p-t80 p-b50	 bg-white inner-page-padding">
        <div className="container">
          <div className="section-content ">
            <div className="our-history text-black">
              <div className="row">
                <div className="col-12 picc-bg-border">
                  <div
                    className="our-historyy-pic bg-no-repeat bg-center bg-cover"
                    data-stellar-background-ratio="0.5"
                    style={{ backgroundImage: `url(${journey6})` }}
                  ></div>
                </div>
                <div className="col-12">
                  <div className="our-history-content m-b30">
                    <div className="large-title">
                      <h4 style={{ color: "#ee6200" }}>2013</h4>
                      <h2 className="m-t0">
                        The First LED Lighting Project in Punjab
                      </h2>
                    </div>
                    {/*  <p>
                  As Indian LED industry was just getting evolved from CFL to
                  LED, and no major manufacturing was visible in India, Spinoff
                  took an initiative to get in manufacturing by starting with
                  R&amp;D driven approach for NPD in led lights , by doing
                  product development in LED bulb with power
                  electronic and thermal treatment of aluminum and plastic with
                  start up space in less then 20,000 sq. ft area in industry area in  Mohali (Punjab) near
                  Chandigarh.
                </p>*/}
                    <p>
                      Visualizing the need for transition from CFL to LED
                      technology, Spinoff created an advanced
                      manufacturing location at Industrial Area, Mohali
                      (Punjab), having the state-of-the-art R&D center and SMT
                      line from Japan. The plant, which spreads over 20,000 Sq.
                      Ft. area, boasts of quality infrastructure and best
                      manufacturing practices in all the segments.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 pic-bg-border">
                  <div
                    className="our-history-pic bg-no-repeat bg-center bg-cover"
                    data-stellar-background-ratio="0.5"
                    style={{ backgroundImage: `url(${journey2})` }}
                  ></div>
                </div>
                <div className="col-12">
                  <div className="our-history-content1 m-b30">
                    <div className="large-title">
                      <h4 style={{ color: "#ee6200" }}>2014-2015</h4>
                      <h2 className="m-t0">Production- Phase-1- 12 SKU</h2>
                    </div>
                    <p>
                      After successful trial of NPD Spinoff started
                      manufacturing LED bulbs, Tube lights and few other SKUs
                      total about 12 nos. in LED lights for different Sizes and
                      shapes with best of quality and production facility in
                      20000 sq ft space.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 pic-bg-border">
                  <div
                    className="our-history-pic bg-no-repeat bg-center bg-cover"
                    data-stellar-background-ratio="0.5"
                    style={{ backgroundImage: `url(${journey3})` }}
                  ></div>
                </div>
                <div className="col-12">
                  <div className="our-history-content m-b30">
                    <div className="large-title">
                      <h4 style={{ color: "#ee6200" }}>2016-2017</h4>
                      <h2 className="m-t0">Production- Phase-2- 40 SKU</h2>
                    </div>
                    {/*<p>
                  After successful commissioning of Phase-1 Spinoff started
                  manufacturing COB lights down lighter and took total SKU from
                  12-40 in Design/Style application/in Home segment of led
                  lights with in-house production supported by in-house R&amp;D-
                  with best of quality and production facility
                </p>*/}
                    <p>
                      After successful commissioning of Phase-1, Spinoff started
                      manufacturing COB lights, thus taking the SKU count from
                      12 to 40. This increased the choice as desired by the customers,based on the
                      functionality , which emerged from 
                      varied designs/different applications in the home segment
                      with innovation from the in-house R&D team.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 pic-bg-border">
                  <div
                    className="our-history-pic bg-no-repeat bg-center bg-cover"
                    data-stellar-background-ratio="0.5"
                    style={{ backgroundImage: `url(${journey4})` }}
                  ></div>
                </div>
                <div className="col-12">
                  <div className="our-history-content2 m-b30">
                    <div className="large-title">
                      <h4 style={{ color: "#ee6200" }}>2018-2019</h4>
                      <h2 className="m-t0">Production- Phase-3- 100 SKU</h2>
                    </div>
                    <p>
                      After successful commissioning of Phase-1 and 2, more and
                      more people preferred to operate LED lights in comparison
                      to CFL lights. As the prices of LED Lights started getting
                      affordable, so the market started generating consistantly
                      high demand for LED Lights, and increased Spinoff's share in
                      market.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 pic-bg-border">
                  <div
                    className="our-history-pic bg-no-repeat bg-center bg-cover"
                    data-stellar-background-ratio="0.5"
                    style={{ backgroundImage: `url(${journey5})` }}
                  ></div>
                </div>
                <div className="col-12">
                  <div className="our-history-content m-b30">
                    <div className="large-title">
                      <h4 style={{ color: "#ee6200" }}>2020</h4>
                      <h2 className="m-t0">Production- Phase-4- 200 SKU</h2>
                    </div>
                    <p>
                      After successful commissioning of Phase-1,2 & 3, Spinoffs' vision grew manifold 
                      and alongwith the market participants like Architects/ Designers volumes increased
                      in both residential and commercial sector. In this phase ,we started working on
                      solar lights in street lights and also industrial lighting
                      for PHARMACEUTICAL and also in INSTITUTIONAL segment which propelled our SKUs count 
                      from 100 to 200 SKUs. This increased the choice to the customers in the 
                      Designs /Style and thus increased the variety of products to the customers.
                      
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 pic-bg-border">
                  <div
                    className="our-history-pic bg-no-repeat bg-center bg-cover"
                    data-stellar-background-ratio="0.5"
                    style={{ backgroundImage: `url(${journey1})` }}
                  ></div>
                </div>
                <div className="col-12">
                  <div className="our-history-content3 m-b30">
                    <div className="large-title">
                      <h4 style={{ color: "#ee6200" }}>2021-2022</h4>
                      <h2 className="m-t0">
                        Phase-5- 600 SKU Plus New Mega factory with 250000 sq
                        feet plot area
                      </h2>
                    </div>
                    <p>
                      This year too in addition to increase in SKU to more then
                      400, Our decision to go ahead  with CNC based  manufacturing helped us to
                      grow multifold in our lighting range as well as other new
                      product development.{" "}
                    </p>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 pic-bg-border">
                  <div
                    className="our-history-pic bg-no-repeat bg-center bg-cover"
                    data-stellar-background-ratio="0.5"
                    style={{ backgroundImage: `url(${journey8})` }}
                  ></div>
                </div>
                <div className="col-12">
                  <div className="our-history-content4 m-b30">
                    <div className="large-title">
                      <h4 style={{ color: "#ee6200" }}>2023-2024</h4>
                      <h2 className="m-t0">
                        Phase-7- 700 SKU Plus New Factory SETUP to commissioned
                        for making Lithium Batteries & Lithium
                        Inverters/Lithium ESS/BSS
                      </h2>
                    </div>
                    <p>
                      This year we launched a state-of-the-art facility
                      dedicated to Research & Development (R&D) and New Product
                      Development (NPD) in the Lithium Space. The focus will be
                      on advancing EV battery storage systems and exploring
                      innovative applications in green energy.
                    </p>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 pic-bg-border">
                  <div
                    className="our-history-pic bg-no-repeat bg-center bg-cover"
                    data-stellar-background-ratio="0.5"
                    style={{ backgroundImage: `url(${journey10})` }}
                  ></div>
                </div>
                <div className="col-12">
                  <div className="our-history-content5 m-b30">
                    <div className="large-title">
                      <h4 style={{ color: "#ee6200" }}>
                        FUTURISTIC JOURNEY AHEAD
                      </h4>
                      <h2 className="m-t0">
                        Production of Battery packs for
                        EV+ESS+UPS+INVERTER+OTHER applications
                      </h2>
                    </div>
                    <p>
                      We intend to create our presence in various power electronic
                      segments connected with Green energy storage system. 
                      The related applications across different segments are-
                      Aeronautical, DRONE, Railways ESS solutions, Portable ESS
                      etc etc , with own set up in R&amp;D , Design house, and
                      own manufacturing set up in Tool room and molding going
                      forward in addition to lithium Energy application based on
                      Engineering.
                    </p>
                  </div>
                </div>
              </div>
              <div className="section-full mobile-page-padding  p-t80 p-b50 bg-white">
                <div className="section-content">
                  <div className="container">
                    {/* TITLE START */}
                   {/* <div className="section-head">
                      <div className="sx-separator-outer separator-center">
                        <div
                          className="sx-separator bg-white bg-moving bg-repeat-x"
                          style={{ backgroundImage: `url(${crossline2})` }}
                        >
                          <h3 className="sep-line-one">Our Machines</h3>
                        </div>
                      </div>
                    </div>*/}
                    {/* TITLE END */}
                  </div>
                  <div className="filter-carousal-1-outer relative z-index1">
                    <div className="container">
                      {/* TITLE START */}
                      {/*<div className="text-center clearfix filter-pos-right shadow m-b30">
                        <ul className="btn-filter-wrap">
                          <li className="btn-filter btn-active" data-filter="*">
                            All
                          </li>
                          <li className="btn-filter" data-filter=".col-one">
                            Manufacturing Units
                          </li>
                        </ul>
                      </div>*/}
                    </div>
                    {/* TITLE END */}
                    <div className="filter-carousal-1 container-fluid p-b30">
                      {/* IMAGE CAROUSEL START */}
                      <div className="section-content">
                        {/*<div className="carousel-container">
                          <div
                            className="carousel"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              transform: `translateX(-${currentIndex * 20}%)`,
                              transition: "transform 0.5s ease-in-out",
                            }}
                          >
                    
                            {data.map((item, index) => (
                              <div
                                key={index}
                                className="item"
                                style={{
                                  width: "calc(40% - 10px)", // Adjust the width to account for the gap (subtracting 10px for margin)
                                  marginRight: "20px", // Add gap between images
                                }}
                              >
                                <div className="sx-box image-hover-block">
                                  <div className="sx-thum-bx">
                                    <img src={item.image} alt={item.title} />
                                  </div>
                                  <div className="sx-info p-t20 text-white">
                                    <h4 className="sx-tilte">
                                      <a href={item.link}>{item.title}</a>
                                    </h4>
                     
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>

                        <br />
                        <br />
                        {/* Carousel Navigation Below */}
                        {/*<div className="carousel-nav">
                          <div className="owl-prev2" onClick={handlePrevious}>
                            Prev
                          </div>
                          <div className="owl-next2" onClick={handleNext}>
                            Next
                          </div>
                        </div>*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ourjourney;
